module.exports = __webpack_public_path__ + "media/assets/images/check_on-0c455524bf403451962e35da2796e947.png";